import App from 'app/app.js';
import LtSelectionDrawerCtrl from 'app/directive/LtSelectionDrawerCtrl.js';

function LtSelectSheetDrawerCtrl($scope, $timeout) {
  LtSelectionDrawerCtrl.call(this, $scope, $timeout);

  this.selectItem = function (selectedItem) {
    $scope.onSelectItem({ selectedItem: selectedItem });
  };
  this.onClose = function () {
    $scope.$broadcast('CYOP_CAROUSEL_RESET');
    $scope.onCancel();
  };
}

App.controller('LtSelectSheetDrawerCtrl', ['$scope', '$timeout', LtSelectSheetDrawerCtrl]);
